import {init} from './appFetch';

export {default as NetworkError} from './NetworkError';

export default {init};
